const SelectionToolData = {
  config: {
    startup: {
      button: 'Averiguar',
      lead:
        '<div class="image"></div><h2>Averigua si tienes candidiasis vaginal</h2>',
      intro:
        "<p><small>(Tiempo aproximado: menos de 1 minuto)</small></p><div class='text-wrap'><p>¿Tienes un flujo inusual y crees que podrías tener candidiasis vaginal o vaginosis bacteriana? No te preocupes, averígualo con solo responder algunas preguntas.</p></div>"
    },
    disclaimers:
      '<p>El objetivo de este Monistat® Symptom Checker (Verificador de síntomas de Monistat®) es proporcionar información para ayudar a las mujeres a seleccionar el producto Monistat® adecuado según sus síntomas. Al acceder a él o utilizarlo, aceptas cumplir con todos los términos y condiciones que se indican a continuación. Este verificador de síntomas no pretende ser un instrumento de diagnóstico médico. Las acciones y productos que sugiere no constituyen un diagnóstico médico de un trastorno específico y no reemplazan el diagnóstico o las recomendaciones formuladas por tu médico. Habla con tu médico si tienes alguna pregunta sobre los productos Monistat®, la dosis o tus síntomas.</p><p>Al usar el Monistat® Symptom Checker (Verificador de síntomas de Monistat®), entiendes y aceptas que la información contenida en este verificador de síntomas no pretende sustituir el asesoramiento médico profesional, no implica serlo y no deberás usarla como tal. Nada de lo contenido en este cuestionario tiene como finalidad que lo utilices como un diagnóstico médico o tratamiento y no deberás usarlo como tal. Comprendes que nunca debes descartar el asesoramiento médico profesional o posponer la búsqueda de un tratamiento en función de la información que aparezca en este verificador de síntomas. Este verificador de síntomas no está dirigido a usuarios de ninguna localidad en particular, ni pretende constituir una transacción comercial en ninguna jurisdicción y así lo aceptas.</p>'
  },
  outcomes: [
    {
      name: 'odor-fresh',
      responses: [
        { id: 1, value: false },
        { id: 2, value: false },
        { id: 5, value: true }
      ],
      content: {
        html:
          '<p><b>Un olor vaginal sin flujo, comezón o irritación, es probablemente normal.</b><br>Sentir ocasionalmente un olor vaginal puede hacernos sentir incómodas. Infórmate sobre las causas del olor vaginal, qué es normal y qué no, y lo que puedes hacer para evitar el olor y sentirte fresca cada día.</p>',
        product: {
          titleText:
            'Un olor vaginal sin flujo, comezón o irritación, es probablemente normal.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/monistat-gel-íntimo-stay-fresh',
          buttonText: 'Elimina el olor',
          productImageUrl: 'product-stayfreshgel.jpg',
          outcomeDescription: `Sentir ocasionalmente un olor vaginal puede hacernos sentir incómodas. Infórmate sobre las causas del olor vaginal, qué es normal y qué no, y lo que puedes hacer para evitar el olor y sentirte fresca cada día.`
        }
      }
    },
    {
      name: 'itch-itch',
      responses: [
        { id: 1, value: true },
        { id: 2, value: false },
        { id: 5, value: false }
      ],
      content: {
        html:
          "<p><b>Itching with no discharge or odor may be normal.</b>Vaginal itching and irritation can occur even if you don't have a vaginal infection. Learn about the symptoms, causes and treatments for vaginal itching and irritation, and find out what you can do to prevent itching and relieve symptoms.</p>",
        product: {
          titleText: 'Tener comezón sin flujo u olor podría ser normal.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/alivio-instantáneo-de-la-comezón',
          buttonText: 'Obtén alivio para la comezón',
          productImageUrl: 'product-instantitchrelief.jpg',
          outcomeDescription: `La comezón y la irritación vaginal pueden ocurrir aunque no se tenga una infección vaginal. Infórmate sobre los síntomas, las causas y los tratamientos de la comezón y la irritación vaginal, y averigua qué puedes hacer para prevenir la comezón y aliviar los síntomas.`
        }
      }
    },
    {
      name: 'trich-itch-1',
      responses: [
        { id: 1, value: true },
        { id: 2, value: true },
        { id: 3, value: 'frothy' },
        { id: 4, value: true }
      ],
      content: {
        html:
          '<p><b>You may have Trich, please see a healthcare professional.</b><br />Trichomoniasis is a sexually transmitted disease (STD) that is caused by the parasite Trichomonas vaginalis. Spread by having unprotected sex with someone who is already carrying the parasite, trichomoniasis is the most common, curable STD in the United States.</p>',
        product: {
          titleText:
            'Quizá tengas tricomoniasis. Haz una cita con un profesional de la salud.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/alivio-instantáneo-de-la-comezón',
          buttonText: 'Obtén alivio para la comezón',
          productImageUrl: 'product-instantitchrelief.jpg',
          outcomeDescription: `La tricomoniasis es una enfermedad de transmisión sexual (STD) causada por el parásito Trichomonas vaginalis. Se propaga por tener relaciones sexuales sin protección con alguien que ya es portador del parásito. La tricomoniasis es la enfermedad de transmisión sexual más común y curable en los Estados Unidos.`
        }
      }
    },
    {
      name: 'trich-itch-2',
      responses: [
        { id: 1, value: true },
        { id: 2, value: true },
        { id: 3, value: 'frothy' },
        { id: 4, value: false }
      ],
      content: {
        html:
          '<p><b>You may have Trich, please see a healthcare professional.</b><br />Trichomoniasis is a sexually transmitted disease (STD) that is caused by the parasite Trichomonas vaginalis. Spread by having unprotected sex with someone who is already carrying the parasite, trichomoniasis is the most common, curable STD in the United States.</p>',
        product: {
          titleText:
            'Quizá tengas tricomoniasis. Haz una cita con un profesional de la salud.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/alivio-instantáneo-de-la-comezón',
          buttonText: 'Obtén alivio para la comezón',
          productImageUrl: 'product-instantitchrelief.jpg',
          outcomeDescription: `La tricomoniasis es una enfermedad de transmisión sexual (STD) causada por el parásito Trichomonas vaginalis. Se propaga por tener relaciones sexuales sin protección con alguien que ya es portador del parásito. La tricomoniasis es la enfermedad de transmisión sexual más común y curable en los Estados Unidos.`
        }
      }
    },
    {
      name: 'trich-cool-1',
      responses: [
        { id: 1, value: false },
        { id: 2, value: true },
        { id: 3, value: 'frothy' },
        { id: 4, value: true }
      ],
      content: {
        html:
          '<p><b>You may have Trich, please see a healthcare professional.</b><br />Trichomoniasis is a sexually transmitted disease (STD) that is caused by the parasite Trichomonas vaginalis. Spread by having unprotected sex with someone who is already carrying the parasite, trichomoniasis is the most common, curable STD in the United States.</p>',
        product: {
          titleText:
            'Quizá tengas tricomoniasis. Haz una cita con un profesional de la salud.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/monistat-toallitas-refrescantes',
          buttonText: 'Siéntete fresca ahora mismo',
          productImageUrl: 'product-coolingcloths.jpg',
          outcomeDescription: `La tricomoniasis es una enfermedad de transmisión sexual (STD) causada por el parásito Trichomonas vaginalis. Se propaga por tener relaciones sexuales sin protección con alguien que ya es portador del parásito. La tricomoniasis es la enfermedad de transmisión sexual más común y curable en los Estados Unidos.`
        }
      }
    },
    {
      name: 'trich-cool-2',
      responses: [
        { id: 1, value: false },
        { id: 2, value: true },
        { id: 3, value: 'frothy' },
        { id: 4, value: false }
      ],
      content: {
        html:
          '<p><b>You may have Trich, please see a healthcare professional.</b><br />Trichomoniasis is a sexually transmitted disease (STD) that is caused by the parasite Trichomonas vaginalis. Spread by having unprotected sex with someone who is already carrying the parasite, trichomoniasis is the most common, curable STD in the United States.</p>',
        product: {
          titleText:
            'Quizá tengas tricomoniasis. Haz una cita con un profesional de la salud.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/monistat-toallitas-refrescantes',
          buttonText: 'Siéntete fresca ahora mismo',
          productImageUrl: 'product-coolingcloths.jpg',
          outcomeDescription: `La tricomoniasis es una enfermedad de transmisión sexual (STD) causada por el parásito Trichomonas vaginalis. Se propaga por tener relaciones sexuales sin protección con alguien que ya es portador del parásito. La tricomoniasis es la enfermedad de transmisión sexual más común y curable en los Estados Unidos.`
        }
      }
    },
    {
      name: 'bv-itch-1',
      responses: [
        { id: 1, value: true },
        { id: 2, value: true },
        { id: 3, value: 'clumpy' },
        { id: 4, value: true }
      ],
      content: {
        html: '<p>You may have BV, please see a healthcare professional.</p>',
        product: {
          titleText:
            'Quizá tengas vaginosis bacteriana. Haz una cita con un profesional de la salud.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/alivio-instantáneo-de-la-comezón',
          buttonText: 'Obtén alivio para la comezón',
          productImageUrl: 'product-instantitchrelief.jpg',
          outcomeDescription: `No se conocen exactamente los motivos por los que las mujeres desarrollan vaginosis bacteriana, pero es la infección vaginal más común entre las mujeres en edad reproductiva.`
        }
      }
    },
    {
      name: 'bv-itch-2',
      responses: [
        { id: 1, value: true },
        { id: 2, value: true },
        { id: 3, value: 'thin' },
        { id: 4, value: true }
      ],
      content: {
        html:
          '<p><b>You may have BV, please see a healthcare professional.</b><br />The reasons that women develop BV are not completely known, but it is the most common vaginal infection among women of childbearing age.</p>',
        product: {
          titleText:
            'Quizá tengas vaginosis bacteriana. Haz una cita con un profesional de la salud.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/alivio-instantáneo-de-la-comezón',
          buttonText: 'Obtén alivio para la comezón',
          productImageUrl: 'product-instantitchrelief.jpg',
          outcomeDescription: `No se conocen exactamente los motivos por los que las mujeres desarrollan vaginosis bacteriana, pero es la infección vaginal más común entre las mujeres en edad reproductiva.`
        }
      }
    },
    {
      name: 'bv-itch-3',
      responses: [
        { id: 1, value: true },
        { id: 2, value: true },
        { id: 3, value: 'thin' },
        { id: 4, value: false }
      ],
      content: {
        html:
          '<p><b>You may have BV, please see a healthcare professional.</b><br />The reasons that women develop BV are not completely known, but it is the most common vaginal infection among women of childbearing age.</p>',
        product: {
          titleText:
            'Quizá tengas vaginosis bacteriana. Haz una cita con un profesional de la salud.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/alivio-instantáneo-de-la-comezón',
          buttonText: 'Obtén alivio para la comezón',
          productImageUrl: 'product-instantitchrelief.jpg',
          outcomeDescription: `No se conocen exactamente los motivos por los que las mujeres desarrollan vaginosis bacteriana, pero es la infección vaginal más común entre las mujeres en edad reproductiva.`
        }
      }
    },
    {
      name: 'bv-cool-1',
      responses: [
        { id: 1, value: false },
        { id: 2, value: true },
        { id: 3, value: 'clumpy' },
        { id: 4, value: false }
      ],
      content: {
        html:
          '<p><b>You may have BV, please see a healthcare professional.</b><br />The reasons that women develop BV are not completely known, but it is the most common vaginal infection among women of childbearing age.</p>',
        product: {
          titleText:
            'Quizá tengas vaginosis bacteriana. Haz una cita con un profesional de la salud.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/monistat-toallitas-refrescantes',
          buttonText: 'Siéntete fresca ahora mismo',
          productImageUrl: 'product-coolingcloths.jpg',
          outcomeDescription: `No se conocen exactamente los motivos por los que las mujeres desarrollan vaginosis bacteriana, pero es la infección vaginal más común entre las mujeres en edad reproductiva.`
        }
      }
    },
    {
      name: 'bv-cool-2',
      responses: [
        { id: 1, value: false },
        { id: 2, value: true },
        { id: 3, value: 'thin' },
        { id: 4, value: true }
      ],
      content: {
        html:
          '<p><b>You may have BV, please see a healthcare professional.</b><br />The reasons that women develop BV are not completely known, but it is the most common vaginal infection among women of childbearing age.</p>',
        product: {
          titleText:
            'Quizá tengas vaginosis bacteriana. Haz una cita con un profesional de la salud.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/monistat-toallitas-refrescantes',
          buttonText: 'Siéntete fresca ahora mismo',
          productImageUrl: 'product-coolingcloths.jpg',
          outcomeDescription: `No se conocen exactamente los motivos por los que las mujeres desarrollan vaginosis bacteriana, pero es la infección vaginal más común entre las mujeres en edad reproductiva.`
        }
      }
    },
    {
      name: 'bv-cool-3',
      responses: [
        { id: 1, value: false },
        { id: 2, value: true },
        { id: 3, value: 'thin' },
        { id: 4, value: false }
      ],
      content: {
        html:
          '<p><b>You may have BV, please see a healthcare professional.</b><br />The reasons that women develop BV are not completely known, but it is the most common vaginal infection among women of childbearing age.</p>',
        product: {
          titleText:
            'Quizá tengas vaginosis bacteriana. Haz una cita con un profesional de la salud.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/monistat-toallitas-refrescantes',
          buttonText: 'Siéntete fresca ahora mismo',
          productImageUrl: 'product-coolingcloths.jpg',
          outcomeDescription: `No se conocen exactamente los motivos por los que las mujeres desarrollan vaginosis bacteriana, pero es la infección vaginal más común entre las mujeres en edad reproductiva.`
        }
      }
    },
    {
      name: 'bv-cool-4',
      responses: [
        { id: 1, value: false },
        { id: 2, value: true },
        { id: 3, value: 'clumpy' },
        { id: 4, value: true }
      ],
      content: {
        html:
          '<p><b>You may have BV, please see a healthcare professional.</b><br />The reasons that women develop BV are not completely known, but it is the most common vaginal infection among women of childbearing age.</p>',
        product: {
          titleText:
            'Quizá tengas vaginosis bacteriana. Haz una cita con un profesional de la salud.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/monistat-toallitas-refrescantes',
          buttonText: 'Siéntete fresca ahora mismo',
          productImageUrl: 'product-coolingcloths.jpg',
          outcomeDescription: `No se conocen exactamente los motivos por los que las mujeres desarrollan vaginosis bacteriana, pero es la infección vaginal más común entre las mujeres en edad reproductiva.`
        }
      }
    },
    {
      name: 'yeast-cure-1',
      responses: [
        { id: 1, value: true },
        { id: 2, value: true },
        { id: 3, value: 'clumpy' },
        { id: 4, value: false }
      ],
      content: {
        html:
          '<p><b>You may have a Yeast Infection.</b><br />A vaginal yeast infection occurs when Candida, a fungus (yeast) normally found in areas like the mouth, digestive tract and vagina, begins to multiply and invade the vaginal tissue. Normally, Candida functions alongside other microorganisms in a delicate balance. When the balance is disrupted, an overgrowth of Candida can lead to a yeast infection.</p>',
        product: {
          titleText: 'Quizá tengas candidiasis vaginal.',
          buttonUrl: '/seleccionador-de-productos',
          buttonText: 'Obtener un tratamiento',
          productImageUrl: 'product-cure.jpg',
          introDescription:
            'Encuentra tu tratamiento rápidamente. Permítenos ayudarte a encontrar el mejor producto para ti para que puedas obtener alivio ahora sin tener que esperar una receta médica.',
          outcomeDescription: `Una candidiasis vaginal se produce cuando la cándida, un hongo (levadura) que se encuentra normalmente en áreas como la boca, el aparato digestivo y la vagina, comienza a multiplicarse e invadir el tejido vaginal. Las cándidas normalmente coexisten con otros microorganismos en un delicado equilibrio. Cuando se altera ese equilibrio, un crecimiento excesivo de cándidas puede provocar una candidiasis vaginal.`
        }
      }
    },
    {
      name: 'yeast-cure-2',
      responses: [
        { id: 1, value: false },
        { id: 2, value: true },
        { id: 3, value: 'clumpy' },
        { id: 4, value: false }
      ],
      content: {
        html:
          '<p><b>You may have a Yeast Infection.</b><br />A vaginal yeast infection occurs when Candida, a fungus (yeast) normally found in areas like the mouth, digestive tract and vagina, begins to multiply and invade the vaginal tissue. Normally, Candida functions alongside other microorganisms in a delicate balance. When the balance is disrupted, an overgrowth of Candida can lead to a yeast infection.</p>',
        product: {
          titleText: 'Quizá tengas candidiasis vaginal.',
          buttonUrl: '/seleccionador-de-productos',
          buttonText: 'Obtener un tratamiento',
          productImageUrl: 'product-cure.jpg',
          introDescription:
            'Encuentra tu tratamiento rápidamente. Permítenos ayudarte a encontrar el mejor producto para ti para que puedas obtener alivio ahora sin tener que esperar una receta médica.',
          outcomeDescription: `Una candidiasis vaginal se produce cuando la cándida, un hongo (levadura) que se encuentra normalmente en áreas como la boca, el aparato digestivo y la vagina, comienza a multiplicarse e invadir el tejido vaginal. Las cándidas normalmente coexisten con otros microorganismos en un delicado equilibrio. Cuando se altera ese equilibrio, un crecimiento excesivo de cándidas puede provocar una candidiasis vaginal.`
        }
      }
    },
    {
      name: 'health-pro-itch',
      responses: [
        { id: 1, value: true },
        { id: 2, value: false },
        { id: 5, value: true }
      ],
      content: {
        html:
          '<p><b>You may have an infection, please see a healthcare professional.</b><br />The three most common forms of vaginitis are yeast infections, bacterial vaginosis (BV), and trichomoniasis. Symptoms for all three can include some form of vaginal discharge, itching, and irritation, so it is important to understand how they are different and what specialized treatment they require.</p>',
        product: {
          titleText:
            'Quizá tengas una infección. Haz una cita con un profesional de la salud.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/alivio-instantáneo-de-la-comezón',
          buttonText: 'Obtén alivio para la comezón',
          productImageUrl: 'product-instantitchrelief.jpg',
          outcomeDescription: `Las tres formas más comunes de vaginitis son candidiasis, vaginosis bacteriana (VB) y tricomoniasis. Los síntomas de las tres pueden incluir alguna forma de flujo vaginal, comezón e irritación, por lo que es importante comprender en qué se diferencian y qué tratamiento especializado requieren.`
        }
      }
    },
    {
      name: 'nothing-cool',
      responses: [
        { id: 1, value: false },
        { id: 2, value: false },
        { id: 5, value: false }
      ],
      content: {
        html:
          "<p><b>No itching with no discharge or odor is usually normal.</b><br />Even if you don't have a vaginal infection now, learn about the symptoms, causes and treatments for vaginal itching and irritation, and find out what you can do to prevent itching and relieve symptoms.</p>",
        product: {
          titleText:
            'Por lo general es normal la ausencia de comezón sin flujo u olor.',
          buttonUrl:
            '/productos-de-cuidado-vaginal-completo/monistat-toallitas-refrescantes',
          buttonText: 'Siéntete fresca ahora mismo',
          productImageUrl: 'product-coolingcloths.jpg',
          outcomeDescription: `Aunque no tengas una infección vaginal en este momento, infórmate sobre los síntomas, las causas y los tratamientos de la comezón y la irritación vaginal, y averigua qué puedes hacer para prevenir la comezón y aliviar los síntomas.`
        }
      }
    }
  ],
  questions: [
    {
      name: 'q1',
      text: '¿Tienes comezón e irritación?',
      id: 1,
      // every question has options even for boolean values
      options: [
        {
          name: 'q1-yes',
          icon: 'fas fa-check',
          value: true
        },
        {
          name: 'q1-no',
          icon: 'fas fa-times',
          value: false
        }
      ]
    },
    {
      name: 'q2',
      text: '¿Tienes un flujo anormal?',
      id: 2,
      options: [
        {
          name: 'q2-yes',
          icon: 'fas fa-check',
          value: true
        },
        {
          name: 'q2-no',
          icon: 'fas fa-times',
          value: false
        }
      ]
    },
    {
      name: 'q4',
      text: '¿Huele mal o a pescado?',
      id: 4,
      prereq: { 2: true },
      options: [
        {
          name: 'q4-yes',
          icon: 'fas fa-check',
          value: true
        },
        {
          name: 'q4-no',
          icon: 'fas fa-times',
          value: false
        }
      ]
    },
    {
      name: 'q3',
      text: '¿Cómo es el flujo?',
      id: 3,
      prereq: { 2: true },
      options: [
        {
          name: 'q3-clumpy',
          text: ' Blanco y grumoso',
          value: 'clumpy'
        },
        {
          name: 'q3-thin',
          text: 'Aguado y blanco o grisáceo',
          value: 'thin'
        },
        {
          name: 'q3-frothy',
          text: 'Espumoso y amarillo verdoso',
          value: 'frothy'
        }
      ]
    },
    {
      name: 'q5',
      text: '¿Tiene olor?',
      id: 5,
      prereq: { 2: false },
      options: [
        {
          name: 'q5-yes',
          icon: 'fas fa-check',
          value: true
        },
        {
          name: 'q5-no',
          icon: 'fas fa-times',
          value: false
        }
      ]
    }
  ],
  textpanes: [
    {
      id: 1,
      html:
        '<div class="textpane-item-wrapper"><div class="icon icon-itch"></div><div class="text"><p>Estas se caracterizan generalmente por una sensación de hormigueo, escozor o ardor en la piel externa que rodea el área vaginal.</p></div></div>'
    },
    {
      id: 2,
      html:
        '<div class="textpane-item-wrapper"><div class="icon icon-discharge"></div><div class="text"><p>El flujo vaginal es una parte normal del sistema de limpieza del cuerpo femenino, diseñado para eliminar las células muertas y proteger la vagina contra las infecciones.</p></div></div>'
    },
    {
      id: 3,
      html:
        '<div class="textpane-item-wrapper"><div class="icon icon-discharge"></div><div class="text"><p>El flujo vaginal diario es normal, pero los cambios específicos pueden ser indicio de diversas infecciones o una infección de transmisión sexual.</p></div></div>'
    },
    {
      id: 4,
      html:
        '<div class="textpane-item-wrapper"><div class="icon icon-odor"></div><div class="text"><p>El olor vaginal puede ser consecuencia de las funciones corporales normales mientras que en otros casos puede indicar infecciones.</p></div></div>'
    },
    {
      id: 5,
      html:
        '<div class="textpane-item-wrapper"><div class="icon icon-odor"></div><div class="text"><p>Cada mujer tiene un olor único que puede cambiar con la fluctuación hormonal a lo largo del mes.</p></div></div>'
    }
  ]
}
export default SelectionToolData
